import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Reveal, Overline } from "@/components/Reveal";
import { ShiNote } from "@/components/ShiNote";
import { IMAGES } from "@/lib/images";

// Shi Sips — the drink ritual. Image-forward, one line, one destination.
export default function ShiSips() {
  return (
    <section
      data-testid="shi-sips-section"
      className="relative overflow-hidden py-28 md:py-36"
    >
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 md:px-10 lg:grid-cols-12 lg:gap-16">
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="relative overflow-hidden rounded-[2rem] border border-corduroy lg:col-span-6"
        >
          <img
            src={IMAGES.drink}
            alt="The Shi Sips bar cart"
            className="aspect-[4/3] w-full object-cover transition-transform duration-700 hover:scale-105"
            loading="lazy"
          />
        </motion.div>

        <Reveal delay={0.1} className="lg:col-span-6">
          <Overline>The Ritual</Overline>
          <h2 className="relative mt-4 font-display text-4xl font-black tracking-tight text-cream md:text-6xl">
            Shi Sips
            <ShiNote className="ml-3 align-middle text-xl md:text-2xl" rotate="-rotate-3">
              pour something.
            </ShiNote>
          </h2>
          <p className="mt-6 max-w-md font-editorial text-2xl italic leading-relaxed text-gold/90 md:text-3xl">
            Every episode of The Program comes with a cocktail on camera and a matching mocktail recipe here.
          </p>
          <Link
            to="/shi-sips"
            data-testid="shi-sips-cta"
            className="mt-10 inline-flex items-center gap-2 rounded-full border border-ember/60 px-7 py-3.5 font-sans text-[11px] font-bold uppercase tracking-[0.24em] text-ember transition-colors hover:bg-ember hover:text-ink"
          >
            Explore Shi Sips <span aria-hidden="true">&rarr;</span>
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
